module.exports = __webpack_public_path__ + "static/media/dgac.96dd88db.png";